import { hostname, userInfo } from 'node:os';

export const NGM_DEV_CLI_PACKAGE_NAME = '@ngm-dev/cli';
export const NGM_DEV_CLI_NAME = '@ngm-dev/cli';
export const NGM_DEV_CLI_NAME_FOR_FILES = 'ngm-dev-cli';

export const MANIFEST_FILE = `${NGM_DEV_CLI_NAME_FOR_FILES}-manifest.json`;
export const CONFIG_FILE = `${NGM_DEV_CLI_NAME_FOR_FILES}.json`;

export const DEFAULT_REGISTRY_HOST = process.env.REGISTRY_HOST ?? 'https://ui.angular-material.dev';
export const DEFAULT_REGISTRY_URL = `${DEFAULT_REGISTRY_HOST}/${process.env.REGISTRY_URL ?? 'api/registry'}`;
export const DEFAULT_NEW_TOKEN_URL = `${DEFAULT_REGISTRY_HOST}/${process.env.NEW_TOKEN_URL ?? 'account/tokens'}`;
export const DEFAULT_REPOS = [DEFAULT_REGISTRY_URL];

// machine ID should be in this format: cli_{userName}@{hostname}_{timestamp}
export const MACHINE_ID = (userName: string) => {
	try {
		return `cli_${userInfo().username}@${hostname}_${Date.now()}`;
	} catch {
		return `cli_${userName}@${hostname}_${Date.now()}`;
	}
};

export const MACHINE_ID_HEADER = 'x-machine-id';
export const USERNAME_HEADER = 'x-username';

export const INDEX_STYLE_BLOCKS = 'styles/ngm-dev-blocks-styles';
export const STYLE_BLOCKS = [
	'styles/themes',
	'styles/vendors',
	'styles/_base',
	'styles/_dialogs',
	'styles/_sizes',
	'styles/_tabs',
	INDEX_STYLE_BLOCKS
];

export const CONFIGURE_NG2_CHARTS = 'CONFIGURE_NG2_CHARTS';
